export interface JobWorkflowDefaultTaskType {
    id: number | null;
    uuid?: string;
    job_workflow_details?: number | null;
    description: string;
    form: number | null;
    required: boolean;
    ordering: number | null;
    deleted: boolean;
}

export const createNewJobWorkflowDefaultTask = (uuid: string, ordering: number): JobWorkflowDefaultTaskType => ({
    id: null,
    uuid: uuid,
    description: '',
    form: null,
    required: false,
    ordering: ordering,
    deleted: false,
});

export interface JobWorkflowDefaultItemType {
    id: number | null;
    uuid?: string;
    job_workflow_details?: number | null;
    product: number | null;
    name: string;
    number?: string | null;
    quantity_string: string | null;
    quantity: number | null;
    initial_used: boolean;
    ordering: number | null;
    deleted: boolean;
}

export const createNewJobWorkflowDefaultItem = (uuid: string, ordering: number): JobWorkflowDefaultItemType => ({
    id: null,
    uuid: uuid,
    product: null,
    name: '',
    quantity_string: null,
    quantity: null,
    initial_used: false,
    ordering: ordering,
    deleted: false,
});
